// extracted by mini-css-extract-plugin
export default {"callout":"Callout_callout__FUNja","calloutHeader":"Callout_calloutHeader__VB4S-","calloutCloseButton":"Callout_calloutCloseButton__wxEvC","calloutBody":"Callout_calloutBody__WR+4d"};